import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { BaseAutocompleteModule } from 'SearchApp/ts/features/base-autocomplete/base-autocomplete.module';

import { IconSearchAutocompleteComponent } from './icon-search-autocomplete.component';

@NgModule({
    imports: [BaseAutocompleteModule, CommonModule],
    declarations: [IconSearchAutocompleteComponent],
    exports: [IconSearchAutocompleteComponent],
})
export class IconSearchAutocompleteModule {}
